import { EventLocationOptions } from '@/stores/EventStore/EventLocationOptions';

export const rawLocationTypeToEventLocationType = ({ rawLocationType }) => {
  return EventLocationOptions[rawLocationType] ?? EventLocationOptions.Location;
};
